export default __webpack_public_path__ + "static/Walt_Disney_World_Resort_logo-50a026cd4b3bb195d3f7aefc18af1006.png";